import React from 'react'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import PublicPageSF from '../../templates/PublicPageSF'
import PasswordResetStep2SF from '../../components/public/PasswordResetStep2SF'

const PasswordHelpStep2PageUI = ({context, step1, step2, onStep1Complete, messageList}) =>
  <PublicPageSF context={context} className='pg_passwd_stp2' backLink='/pub/password-help'
      messageList={messageList} headerMessageKey='c_reset_password'>
    <PageTitleUI context={context} goBack={true} backLink='/' messageList={messageList}
      titleMessageKey='c_reset_password' />

    <PasswordResetStep2SF context={context} messageList={messageList} />

  </PublicPageSF>

export default PasswordHelpStep2PageUI
